export default "__VITE_ASSET__YTGFSU16__"